export enum PlanType {
  BASIC = 'basic',
  STANDARD = 'standard',
  PLUS = 'plus',
}
